import logoImage from '../assets/images/wealthbrainai.jpg';

export function FinSightLogo({ variant = "full", size = "md", className = "" }) {
  const sizes = {
    xs: { height: 24, fontSize: "text-base" },
    sm: { height: 32, fontSize: "text-lg" },
    md: { height: 40, fontSize: "text-xl" },
    lg: { height: 56, fontSize: "text-2xl" },
    xl: { height: 72, fontSize: "text-3xl" },
  };

  const currentSize = sizes[size] || sizes.md;

  // Since we are replacing the entire logo with an image, 
  // we'll use the height from the size mapping to ensure consistency.
  
  return (
    <div className={`inline-flex items-center bg-white rounded-sm ${className}`}>
      <img 
        src={logoImage} 
        alt="WealthBrain AI" 
        className="object-contain bg-white"
        style={{ height: currentSize.height, width: 'auto' }}
      />
    </div>
  );
}
